export function getClusterMarkerSize(count: number): number {
  if (count >= 100) {
    return 120
  }
  if (count >= 10) {
    return 72
  }
  return 40
}
